module.exports = __webpack_public_path__ + "img/1585425587.b21ec246.jpg";